/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Section, Content, Copy, Title, Link, Grid, GridSet, GridItem, Icon, DateRangePickerDropDown, MultiSelectDropDown, ListTable, Control, LineChart } from '@insticator/insticator-ui'; // iui-material
//utils
import { isAfterFourPM, getDateNYC } from '@insticator/insticator-ui'; // iui-utils
import { transpileTableBody, transpileByDateTableColumnHead, detailChartData } from 'utils/transpilers/datavisualization';
import { generateMetricsAPIString } from 'utils/fetchcontenthelpers';
import { getAllDetailData } from 'utils/api/detail';
import { handleSiteInDropDown, handleCountriesInDropDown, handleDevicesInDropDown, handleEmbedsInDropDown, handleStoriesInDropDown } from 'pages/dashboard/analytics/detail/detailhelpers';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/analytics/detail/metrics/storyclicks/storyclicks_styles';



/* ========== ~~~~~~~~~~ DATA STORY CLICKS ~~~~~~~~~~ ========== */
class StoryClicks extends Component {
    constructor(props){
        super(props);
        this.topRank = 15;
        this.dataType = 'storyclicks';
        this.state={
            controlSelected: `STORY`
        }
    }

    componentWillMount(){
        this.props.getStories(this.props.accountUUID);
        const extendedParams = this.hereFromAnalytics() ? {stories: this.props.selectedStories} : {topRank: this.topRank};
        this.fetchDetailStoryClicks(this.state.controlSelected, extendedParams);
    }
    componentWillUnmount() {
        this.props.clearDetailState();
    }
    //fetch data call
    fetchDetailStoryClicks = (controlSelected, extendAPIProps) => this.props.getDetailStoryClicks(generateMetricsAPIString({accountUUID: this.props.accountUUID, dateRange: this.props.dateRange, viewType: controlSelected, ...extendAPIProps}));

    handleChartValue = data => {
        let value = data.total && data.total.aggregate ? data.total.aggregate : null;
        if (!value) return;
        return parseFloat(value).toLocaleString('en-US')
    };
    //-=-=-=Control actions-=-=-=//
    handleSitesControlClick = () => {
        this.props.updateDetailDropDown([], 'SITE');
        this.setState({controlSelected: 'SITE'});
        this.fetchDetailStoryClicks('SITE', {topRank: this.topRank});
    };
    handleDevicesControlClick = () => {
        this.setState({controlSelected: 'DEVICE'});
        this.fetchDetailStoryClicks('DEVICE', {topRank: this.topRank});
    };
    handleGeoControlClick = () => {
        this.setState({controlSelected: 'GEO'});
        this.props.fetchCountries(this.props.accountUUID, `?startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}`);
        this.fetchDetailStoryClicks('GEO', {topRank: this.topRank});
    };
    handleEmbedsControlClick = () => {
        this.setState({controlSelected: 'EMBED'});
        this.props.fetchEmbeds(this.props.accountUUID);
        this.fetchDetailStoryClicks('EMBED', {topRank: this.topRank});
    };
    handleStoryControlClick = () => {
        this.setState({controlSelected: 'STORY'});
        this.props.getStories(this.props.accountUUID);
        this.fetchDetailStoryClicks('STORY', {topRank: this.topRank});
    };
    //-=-=-=-=--Filter Data Dropdown actions -=-=-=-=//
    handleSitesFilterApply = sites => this.fetchDetailStoryClicks(this.state.controlSelected, { sites });
    handleDevicesFilterApply = devices => this.fetchDetailStoryClicks(this.state.controlSelected, { devices });
    handleGeoFilterApply = countries => this.fetchDetailStoryClicks(this.state.controlSelected, { countries });
    handleEmbedFilterApply = embeds => this.fetchDetailStoryClicks(this.state.controlSelected, { embeds });
    handleStoryFilterApply = stories => this.fetchDetailStoryClicks(this.state.controlSelected, { stories });
    handleDateRangeApply = () => this.fetchDetailStoryClicks(this.state.controlSelected, {topRank: this.topRank});
    //this function will take selected items and populate reducer based on controlSelected state
    handleDropDownSelect = (items) => this.props.updateDetailDropDown(items, this.state.controlSelected);

    //this method returns an object that contains props needed to export current metrics that are displayed on screen in to an excel file
    //fileName and excludedColumns
    exportCurrentProps = () => ({
        fileName: this.dataType,
        excludedColumns: ['embed_uuid', '']
    });
    //this method returns an object that contains props needed to export current metrics that are displayed on screen in to an excel file
    //fileName, excludedColumns, and a paramstring that is used to make a BE call to fetch data for all sites, adunits, countries, etc. depending on current viewType
    exportAllProps = () => ({
        apiCall: getAllDetailData('storyclicked'),
        fileName: this.dataType,
        excludedColumns: ['embed_uuid', ''],
        transpiler: transpileTableBody,
        paramString: generateMetricsAPIString({
            accountUUID: this.props.accountUUID,
            dateRange: this.props.dateRange,
            viewType: this.state.controlSelected,
            dataType: this.dataType
        })
    });
    hereFromAnalytics = () => this.props.previousPage === 'dashboard/embeds/analytics/embedcontent';
    renderBackLink = () => {
       if(this.hereFromAnalytics()){
          return <Link type={`internal`} behavior={`back`} text={`Back to embed metrics`} color={`primary`} action={`dashboard/embeds/analytics/embedcontent`} icon={`hand-point-left`} />;

       }else{
           return <Link type={`internal`} behavior={`back`} text={`Back to all metrics`} color={`primary`} action={`dashboard/home`} icon={`hand-point-left`} />;
       }
    };
    render() {
        return(
            <Page name={`storyclicks`} klass={`${this.props.classes.storyclicks} filter-${this.state.controlSelected}`}>
                <Content>

                    <Section name={`detailheader`}>
                        <Grid>
                            <GridSet direction={`horizontal`} name={`detailtitle`}>
                                <GridItem>
                                    <Copy>
                                        <Title><h2>{'Story clicks'}</h2></Title>
                                        {this.renderBackLink()}
                                    </Copy>
                                </GridItem>
                                <GridItem>
                                    <DateRangePickerDropDown handleApply={this.handleDateRangeApply} range={this.props.dateRange} disabledDays={[ { after: new Date(getDateNYC() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2))) } ]} updateRange={this.props.updateDateRange} use4PMLogic={true} />
                                </GridItem>
                            </GridSet>
                            <GridSet direction={`horizontal`} name={`detailfilters`}>
                                <GridItem name={`filters`}>
                                    <GridItem><MultiSelectDropDown name={this.props.selectedStories.length === 1 ? 'story' : 'stories'} title={'All Stories'} icon={`book`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleStoryFilterApply} items={handleStoriesInDropDown(this.props.stories)} selectedItems={this.props.selectedStories}/></GridItem>
                                    <GridItem><MultiSelectDropDown variant={'all-sites'} name={this.props.selectedSites.length === 1 ? 'site' : 'sites'} title={'All Sites'} icon={`link`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleSitesFilterApply} items={handleSiteInDropDown(this.state.controlSelected === 'AD_UNIT' ? this.props.ronSites : this.props.sites)} selectedItems={this.props.selectedSites}/></GridItem>
                                    <GridItem><MultiSelectDropDown name={this.props.selectedDevices.length === 1 ? 'device' : 'devices'} title={'All Devices'} icon={`mobile-alt`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleDevicesFilterApply} items={handleDevicesInDropDown(this.props.devices)} selectedItems={this.props.selectedDevices}/></GridItem>
                                    <GridItem><MultiSelectDropDown name={this.props.selectedCountries.length === 1 ? 'country' : 'countries'} title={'All Countries'} icon={`globe`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleGeoFilterApply} items={handleCountriesInDropDown(this.props.countries)}  selectedItems={this.props.selectedCountries}/></GridItem>
                                    <GridItem><MultiSelectDropDown name={this.props.selectedEmbeds.length === 1 ? 'embed' : 'embeds'} title={'All Embeds'} icon={`globe`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleEmbedFilterApply} items={handleEmbedsInDropDown(this.props.embeds)}  selectedItems={this.props.selectedEmbeds}/></GridItem>
                                </GridItem>
                                <GridItem direction={`horizontal`} name={`controls`}>
                                    <Control selected={this.state.controlSelected === `STORY`} text={`Stories`} value={`STORY`} handleSelect={this.handleStoryControlClick} />
                                    <Control selected={this.state.controlSelected === `SITE`} text={`Sites`} value={`SITE`} handleSelect={this.handleSitesControlClick} />
                                    <Control selected={this.state.controlSelected === `DEVICE`} text={`Devices`} value={`DEVICE`} handleSelect={this.handleDevicesControlClick} />
                                    <Control selected={this.state.controlSelected === `GEO`} text={`Geo`} value={`GEO`} handleSelect={this.handleGeoControlClick} />
                                    <Control selected={this.state.controlSelected === `EMBED`} text={`Embeds`} value={`EMBED`} handleSelect={this.handleEmbedsControlClick} />
                                </GridItem>
                            </GridSet>
                        </Grid>
                    </Section>

                    <Section name={`detailchart`}>
                        <LineChart
                            type={`detail`}
                            label={'Clicks'}
                            xType={'date'}
                            value={this.handleChartValue(this.props.storyClicks)}
                            tooltip={'These are the total numbers of Stories that have been clicked for your embed(s)'}
                            data={detailChartData(this.props.storyClicks)}
                            loading={this.props.storyClicksFetching}
                        />
                    </Section>

                    <Section name={`detailtable`}>
                        <ListTable
                            name={`storyclicks`}
                            type={`fixed-column`}
                            fixedColWidth={300}
                            size={`full`}
                            columnHeads={transpileByDateTableColumnHead(this.props.storyClicks)}
                            data={transpileTableBody(this.props.storyClicks)}
                            exportData={this.exportCurrentProps()}
                            exportAll={this.exportAllProps()}
                            paginationLocation={`top`}
                            rowsPerPage={7}
                            loading={this.props.storyClicksFetching}
                            moreDetails={false}
                        />
                    </Section>

                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

export default injectSheet(styles)(StoryClicks);
